
import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { AccountModel } from '../../../Core/Users/models/account.model';
import { accountServicesEnum } from '../../../Core/Users/enums/account-services.enum';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

@Injectable()
export class AdminRouteGuard implements CanActivate {


    constructor(private currentUserState: CurrentUserStateService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserState.getPermissions().pipe(
            filter(x => x !== null),
            map(permissions => {
                if (permissions.find(x => x === userPermissionsEnum.accountManager)) {
                    return true;
                } else {
                    return false;
                }
            })
        );
    }
}
